define('lib/Podio.Config',['require','jquery','jquery.cookie','moment','translate','lib/Podio.Bootstrap'],function(require) {

  var $ = require('jquery');
  require('jquery.cookie');
  var moment = require('moment');
  var t = require('translate');

  var bootstrap = require('lib/Podio.Bootstrap');
  var config = bootstrap.getBootstrapData("PodioConfig", true) || {};

  // Get updated session
  config.authenticity_token = function() {
    return $.cookie(config.authenticity_identifier);
  };

  // Inject time offset into config
  if (config.serverTime) {
    config.serverTimeOffset = config.serverTime-moment.utc().unix();
    if (Math.abs(config.serverTimeOffset) < 10 || Math.abs(config.serverTimeOffset) > 60*15) {
      // Don't trust the calculated offset if it is less than 10 seconds or more than 15 minutes
      config.serverTimeOffset = 0;
    }
  }

  // Load podio locale settings
  var localeSettings = bootstrap.getBootstrapData("LocaleSettings", true);
  if (localeSettings) {
    // Compile regular expressions
    localeSettings.validations.date_regexp = new RegExp(localeSettings.validations.date_regexp);
    localeSettings.validations.number_regexp = new RegExp(localeSettings.validations.number_regexp);

    config.localeSettings = localeSettings;
  }

  // Developers message
  if(config.environment === 'production' && window.console && window.console.log) {
    window.console.log(t('Like playing around in the console? Why not help us build Podio? - https://www.progress.com/company/careers'));
  }

  return config;
});

